import {Component, Input, TemplateRef, ViewChild} from '@angular/core';

@Component({
  selector: 'tab-content',
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class TabContentComponent {
  @Input() active: boolean;
  @ViewChild(TemplateRef) template: TemplateRef<any>;
}
